import { IconClose } from "@/assets/icons";
import { IconBox } from "@/components/elements/IconBox";
import { METRIC_CONFIG } from "@/features/dashboard/constants/matching-results-columns";
import { TMatchingResultsMetric } from "@/features/dashboard/types/matching-results";
import { Stack, Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";

type TMatchingResultsModalHeaderProps = {
  metric: TMatchingResultsMetric;
  targetMonth: Dayjs | string;
  onClose?: () => void;
};

// Full-width gray header (56px) bleeding over Modal's 24px padding.
// Per SVG spec: bg #E6E7E8, text #2E3436, close icon #767B7E, radius 8px top corners.
export const MatchingResultsModalHeader: FC<TMatchingResultsModalHeaderProps> = ({ metric, targetMonth, onClose }) => {
  const monthDayjs = typeof targetMonth === "string" ? dayjs(targetMonth, "YYYY-MM") : targetMonth;
  const metricLabel = METRIC_CONFIG[metric].label;
  const titleText = `${monthDayjs.format("YYYY年MM月")}の${metricLabel}`;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        mx: "-24px",
        mt: "-24px",
        mb: 0,
        px: "24px",
        height: 56,
        width: "calc(100% + 48px)",
        backgroundColor: "#E6E7E8",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        flexShrink: 0,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        <Typography variant="sub16Semi" sx={{ color: "#2E3436" }}>
          マッチング実績値
        </Typography>
        <Typography sx={{ color: "#2E3436" }}>｜</Typography>
        <Typography variant="sub16Semi" sx={{ color: "#2E3436" }} noWrap>
          {titleText}
        </Typography>
      </Stack>
      <IconBox onClick={onClose} sx={{ p: 0 }}>
        <IconClose color="#767B7E" fontSize={24} />
      </IconBox>
    </Stack>
  );
};
